module.exports = __webpack_public_path__ + "img/right_video2.18a82233.png";